import type { CodeResponse } from '@/types/http/api'
import { LOGIN_ROUTE } from '@/router/constants'
import { resetAllStores } from '@/store'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

function isCodeResp<T>(d: unknown): d is CodeResponse<T> {
  return !!d && typeof d === 'object' && 'code' in (d as any) && 'data' in (d as any)
}

export const makeCodeResponseParser = () =>
  function codeResponseParser<T, R = CodeResponse<T>>(
    res: AxiosResponse<R>,
  ): T | Promise<T> | undefined {
    const { data: resData, config } = res as any
    if (!isCodeResp<T>(resData)) return undefined

    const { code, data, message = '' } = resData
    if (code === 200) return (data ?? null) as T

    if (code === 10086) {
      const originalCfg: AxiosRequestConfig = { ...(config || {}) }
      const err: any = new Error('MFA_REQUIRED')
      err.mfa = {
        securityCode: (data as any).security_code,
        originalCfg,
        data,
      }
      throw err
    }

    if (code === 401) {
      resetAllStores?.()
      if (window.location.pathname !== LOGIN_ROUTE.path) {
        const { pathname, search, hash } = window.location
        const redirect = encodeURIComponent(`${pathname}${search}${hash}`)
        const joiner = LOGIN_ROUTE.path.includes('?') ? '&' : '?'
        const redirectUrl = `${LOGIN_ROUTE.path}${joiner}redirect=${redirect}`
        console.log('redirectUrl', redirectUrl)
        window.location.replace(redirectUrl)
      }
      /* if (window.location.pathname !== LOGIN_ROUTE.path) {
        window.location.replace(LOGIN_ROUTE.path)
      } */
      throw new Error('UNAUTHENTICATED')
    }

    window.GtcNotification('error', message || '后端错误')
    console.error('codeResponseParser', message)
    throw new Error(message || '后端错误')
  }

export const axiosDataFallbackParser = <T = any>(res: AxiosResponse<any>): T | undefined => {
  try {
    if (res && typeof res === 'object' && 'data' in res) return res.data as T
  } catch {
    // ignore
  }
  return undefined
}
